import {
  isChatFlightSavedItemData,
  isCustomFlightSavedItemData,
  isLeFlightSavedItemData,
  type LeFlightSavedItemData,
  type TransportOption,
} from 'tripPlanner/api/types'
import { isRecord } from 'lib/object/objectUtils'
import { parseFlightSearchParams as parseSearchParams } from 'tripPlanner/components/Chat/Flights/parseFlightSearchParams'
import type { RefreshedFlight } from './flightShortlistTypes'
import { getSavedFlightPerPersonPrice } from 'tripPlanner/components/Chat/Flights/flightPartyPricing'

function isFlightOptionBooked(option: TransportOption): boolean {
  const savedItemData = option.savedItemData
  const isSavedItemDataBooked = (
    isLeFlightSavedItemData(savedItemData) ||
    isChatFlightSavedItemData(savedItemData) ||
    isCustomFlightSavedItemData(savedItemData)
  ) && savedItemData.isBooked === true
  return ('isBooked' in option && option.isBooked === true) || isSavedItemDataBooked
}

function isBookedFlightOption(option: TransportOption): boolean {
  return isFlightOptionBooked(option) || (!!option.returnLeg && isFlightOptionBooked(option.returnLeg))
}

// Recovers currencyCode from the serialized searchParams blob.
function parseSearchParamsCurrency(searchParams: string | undefined): string | undefined {
  if (!searchParams) return undefined
  try {
    const parsed: unknown = JSON.parse(searchParams)
    if (!isRecord(parsed)) return undefined
    const code = parsed.currencyCode
    return typeof code === 'string' && code.length > 0 ? code : undefined
  } catch {
    return undefined
  }
}

interface PriceAndCurrency {
  displayPrice?: number
  regularPrice?: number
  isLuxPlusFare?: boolean
  priceCurrency?: string
}

// Pairs price+currency from one source (refresh or saved), never mixed.
function resolveShortlistedFlightPriceAndCurrency(args: {
  isReturn: boolean
  savedItemData: LeFlightSavedItemData | undefined
  refreshedData: RefreshedFlight | undefined
}): PriceAndCurrency {
  const { savedItemData, refreshedData } = args
  if (!savedItemData) return {}

  const { price: savedPrice, regularPrice: savedRegularPrice, currencyCode: savedCurrency } = getSavedFlightPerPersonPrice(savedItemData)

  const refreshHasPrice = refreshedData?.newPrice !== undefined
  const displayPrice = refreshHasPrice ? refreshedData?.newPrice : savedPrice
  const regularPrice = refreshHasPrice ? refreshedData?.newRegularPrice : savedRegularPrice
  const isLuxPlusFare = refreshHasPrice ? refreshedData?.isLuxPlusFare : savedRegularPrice !== undefined ? true : undefined
  const priceCurrency = refreshHasPrice
    ? refreshedData?.newCurrencyCode
    : savedCurrency

  return { displayPrice, regularPrice, isLuxPlusFare, priceCurrency }
}

export {
  parseSearchParams,
  isBookedFlightOption,
  parseSearchParamsCurrency,
  resolveShortlistedFlightPriceAndCurrency,
}
